import { useIntl } from "react-intl";

import { usePatientName } from "src/features/patient";
import { useAddress } from "src/modules/basic-health/header/hooks/useAddress";
import { useAge } from "src/modules/basic-health/header/hooks/useAge";
import { useBloodGroup } from "src/modules/basic-health/header/hooks/useBloodGroup";
import { useBmi } from "src/modules/basic-health/header/hooks/useBmi";
import { useHeight } from "src/modules/basic-health/header/hooks/useHeight";
import { useLongStatus } from "src/modules/basic-health/header/hooks/useLongStatus";
import { usePhoneNumber } from "src/modules/basic-health/header/hooks/usePhoneNumber";
import { useSocialSecurityNumber } from "src/modules/basic-health/header/hooks/useSocialSecurityNumber";
import { useWeight } from "src/modules/basic-health/header/hooks/useWeight";
import { messages } from "src/modules/basic-health/header/messages";

export function useHeaderValues(): { label?: string; value?: string }[] {
	const { formatMessage } = useIntl();
	const name = usePatientName();
	const status = useLongStatus();
	const ssn = useSocialSecurityNumber();
	const address = useAddress();
	const phoneNumber = usePhoneNumber();
	const { value: bloodGroup } = useBloodGroup();
	const age = useAge();
	const { value: weight } = useWeight();
	const { value: height } = useHeight();
	const { value: bmi } = useBmi();
	return [
		{ label: formatMessage(messages.name), value: name },
		{ label: formatMessage(messages.status), value: status },
		{ label: formatMessage(messages.ssn), value: ssn },
		{ label: formatMessage(messages.address), value: address },
		{ label: formatMessage(messages.phoneNumber), value: phoneNumber },
		{ label: formatMessage(messages.bloodGroup), value: bloodGroup },
		{ label: formatMessage(messages.age), value: age },
		{ label: formatMessage(messages.weight), value: weight },
		{ label: formatMessage(messages.height), value: height },
		{ label: formatMessage(messages.bmi), value: bmi }
	];
}
